import { sectionTitleSlideV2 } from '../../../../../slides/shared/section-title-slide-v2';

export const visitLiftTitleSlideV2 = () => sectionTitleSlideV2('Visit Lift');
